import {
	captureMarketingAttribution,
	clearMarketingAttribution,
	readMarketingAttribution,
	type MarketingAttribution,
} from "@kitsulab/schema";

export function captureMarketingAttributionFromCurrentLocation(): void {
	captureMarketingAttribution(
		new URL(window.location.href),
		window.localStorage,
	);
}

export function getStoredMarketingAttribution(): MarketingAttribution | null {
	return readMarketingAttribution(window.localStorage);
}

export function clearStoredMarketingAttribution(): void {
	clearMarketingAttribution(window.localStorage);
}
